import PostLogin from "pages/auth/PostLogin";

export default PostLogin;

